(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/jupiter-helper.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/jupiter-helper.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let jupiter;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiter = trinidad.jupiter;
  logger = trinidad.logger('module:arena');
} else {
  jupiter = svs.core.jupiter;
  logger = svs.arena.logger;
}

const streamlinedJupiterCall = async options => {
  let response;
  let status;
  try {
    var _response;
    if (isServer) {
      const apiResponse = await jupiter.callAsync(options);
      status = apiResponse ? 'success' : 'Api response missing';
      response = apiResponse;
    } else {
      var _await$jupiter$callAs = await jupiter.callAsync(options);
      response = _await$jupiter$callAs.response;
      status = _await$jupiter$callAs.status;
    }
    return {
      error: status === 'success' ? null : ((_response = response) === null || _response === void 0 ? void 0 : _response.error) || 'error',
      data: status === 'success' ? response : null
    };
  } catch (err) {
    logger.info("Error getting ".concat(options.path), err);
    return {
      error: err,
      data: null
    };
  }
};
const exportedFunctions = {
  streamlinedJupiterCall
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.arena.service.jupiterHelper = exportedFunctions;
}

 })(window);